import { Frequency, StripePaymentMethod } from "../types"

export function shouldSavePaymentMethod({
  frequency,
  stripePaymentMethod,
  savePaymentMethodChecked,
}: {
  frequency: Frequency
  stripePaymentMethod?: StripePaymentMethod
  savePaymentMethodChecked: boolean
}) {
  const savedPaymentMethod = stripePaymentMethod?.id !== undefined
  const missingPaymentMethod = stripePaymentMethod === undefined
  const recurringDonation = frequency.type !== "once"
  const bankAccount =
    stripePaymentMethod?.type === "us_bank_account" ||
    stripePaymentMethod?.type === "au_becs_debit"
  const savePaymentMethodCheckedForCard =
    stripePaymentMethod?.type === "card" && savePaymentMethodChecked
  return (
    !savedPaymentMethod &&
    !missingPaymentMethod &&
    (recurringDonation || bankAccount || savePaymentMethodCheckedForCard)
  )
}
